import TimePicker from './time-picker.vue'
export type { TimePickerProps } from './props'
export default TimePicker